import React from 'react';
import { useTranslation } from 'react-i18next';
import CommonDialog from './commonModal';
import { isMobile } from '../../commonUtil/responsiveUtil';

const getModalStyle = () => {
    let ErrorModalStyle = {
        overlay: {
            zIndex: 10003
        },
        content: {
            width: '500px',
            borderRadius: '4px'
        }
    };

    if (isMobile()) {
        const content = {
            width: '100%',
            borderRadius: '4px'
        };

        ErrorModalStyle = {
            ...ErrorModalStyle,
            content
        };
    }

    return ErrorModalStyle;
};

const ErrorModal = (props) => {
    const { isOpen, afterCloseModal, errorInfo, highlightColor, className, setIsOpen } = props;
    const modalStyle = getModalStyle();
    const { t } = useTranslation();

    const closeErrorModal = () => {
        setIsOpen(false);
    };

    return (
        <CommonDialog
            shouldCloseOnOverlayClick={false}
            showCloseIcon
            afterCloseModal={afterCloseModal}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            customStyles={modalStyle}
            className={`seismic-engagement-viewer-message-dialog ${className}`}>
            <div className="message-dialog-header">
                <span className="message-dialog-header-text">{errorInfo.title || t('LIVE_SEND_VIEWER_WARNING')}</span>
            </div>
            <div className="message-dialog-content">
                <span>{errorInfo.message}</span>
            </div>
            <div className="message-dialog-footer">
                <button className="enagement-buyer-btn btn-active btn-okay"
                    onClick={closeErrorModal}
                    style={{ backgroundColor: highlightColor }}
                >{t('LIVE_SEND_VIEWER_OKAY')}</button>
            </div>
        </CommonDialog>
    );
};

export default ErrorModal;
